import axios from 'axios';

import store from '../store/index';

function checkTourTimeZones (clientId) {
  return axios.get('api/client/' + clientId + '/analytics/timezones');
}

function importFile (postData) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/analytics', postData.data, postData.config)
    .then((response) => {
      store.dispatch('analytics/isUploadingOff');
      store.dispatch('analytics/loadImportResults', response.data);
    });
}

function getAnalytics (data) {
  return axios.get('api/client/' + data.clientId + '/analytics?' +
    'dateRange=' + data.dateRange +
    '&language=' + data.language +
    '&tourId=' + data.tourId +
    '&routeId=' + data.routeId
  ).then((response) => {
    store.dispatch('analytics/isLoadingOff');
    store.dispatch('analytics/loadAnalytics', response.data);
  });
}

export {
  checkTourTimeZones,
  getAnalytics,
  importFile
};



// WEBPACK FOOTER //
// ./src/services/AnalyticsService.js